export default __webpack_public_path__ + "static/media/mobilewarning.95c300cd.png";